const MUTE_KEY = 'ludoMuted';
const SOUND_BASE_PATH = '/assiste-ludo/audio';
const SOUND_FILES = {
    dice: 'diceroted.mp3',
    move: 'pawanmoov.mp3',
    win: 'win.mp3',
    kill: 'click.mp3',
    six: 'click.mp3',
    home: 'inhome.mp3',
    safe: 'insafe.mp3',
    yourTurn: 'ticktick.mp3',
    join: 'click.mp3',
    leave: 'click.mp3',
};

const sounds = {};
let muted = false;

try { muted = JSON.parse(localStorage.getItem(MUTE_KEY)) === true; } catch {}

function load(key, src) {
    const audio = new Audio(src);
    audio.preload = 'auto';
    sounds[key] = audio;
}

Object.entries(SOUND_FILES).forEach(([key, fileName]) => {
    load(key, `${SOUND_BASE_PATH}/${fileName}`);
});

function play(key) {
    if (muted) return;
    try {
        const audio = sounds[key];
        if (!audio) return;
        audio.currentTime = 0;
        audio.play().catch(() => {});
    } catch {}
}

const soundManager = {
    isMuted: () => muted,

    setMuted(val) {
        muted = val;
        try { localStorage.setItem(MUTE_KEY, JSON.stringify(val)); } catch {}
    },

    toggleMute() {
        this.setMuted(!muted);
        return muted;
    },

    playDice() { play('dice'); },

    playMove() { play('move'); },

    playWin() { play('win'); },

    playKill() {
        play('kill');
    },

    playSix() {
        play('six');
    },

    playHome() {
        play('home');
    },

    playSafe() {
        play('safe');
    },

    playYourTurn() {
        play('yourTurn');
    },

    playJoin() {
        play('join');
    },

    playLeave() {
        play('leave');
    },
};

export default soundManager;
